<!-- ===== DASHBOARD SECTION BELOW ===== -->
<div  class="page-layout blank fullwidth" (scroll)="onScroll()" fusePerfectScrollbar style="height: 1px; overflow-y: scroll; margin-bottom: 5em;    top: 1px;    background: linear-gradient(45deg, #e2e8f8, #F8FAFF);" >
  <div class="dashboard-wrapper">
          <div class="asp-dashboard" *ngIf="hasDashboardData">

            <div class="asp-dashboard__greeting">
              <div class="left">
                <strong>{{ greeting }}, {{spareSelectedGarageName}} 👋</strong>
              </div>
              <div class="right">
                <button class="asp-home-new-button" (click)="loadrequest()">🚗 Create New Request ➜</button>
                <ng-template #requestorder></ng-template>
                <span class="bell">🔔</span>
              </div>
            </div>
            <div class="asp-dashboard__actions" *ngIf="hasDashboardData">
              <button  (click)="loadOrderList()">
                <div class="track-btn">📦</div>
                <div class="track-btn-txt">Track Orders</div>
              </button>
              <button  (click)="loadMakePayment()">
                <div class="pay-btn">💳</div>
                <div class="pay-bt-txt">Make Payment</div>  
              </button>
            </div>
            <div class="asp-dashboard__todo" *ngIf="pendingCount > 0 || totalDues > 0">
              <div class="asp-dashboard__todo-header"  *ngIf="pendingCount > 0 || totalDues > 0">
                <h3><span class="todo-icon" style="color:#4a3500 ;">📋</span> Today's To-Do</h3>
                <span class="pending"  *ngIf="pendingCount > 0">• {{ pendingCount }} pending</span>
              </div>

              <div class="asp-dashboard__todo-item" *ngIf="pendingCount > 0">
                <p>🧾 Quotes awaiting approval: <strong>{{ pendingCount }}</strong></p>
                <button class="review-btn" (click)="goToRequestsByStatus(8)"> Review</button>

              </div>

              <div class="asp-dashboard__todo-item" *ngIf="totalDues > 0">
                <div class="another-p">💰 Total Dues: <strong>₹{{ totalDues | number:'1.2-2' }}</strong></div>

                <button class="paynow-btn"  (click)="loadMakePayment()">Pay Now</button>
              </div>
            </div>
            <div class="asp-dashboard__snapshot" *ngIf="  totalSavings > 0 ||  totalPurchase > 0 || totalOrders > 0 ||   oesPercentage > 0 ">
              <h3>📊 Monthly Snapshot • {{month}}</h3>

              <div class="asp-dashboard__grid">
                <div class="card" *ngIf="totalSavings > 0">
                  <p>🎉 Savings</p>
                  <h4>{{ totalSavings | number:'1.2-2' }}</h4>
                </div>

                <div class="card" *ngIf="totalPurchase > 0">
                  <p>💸 Total Purchase</p>
                  <h4>₹{{ totalPurchase | number:'1.2-2' }}</h4>
                </div>

                <div class="card small"  *ngIf="totalOrders > 0">
                  <p>📦 Orders</p>
                  <h4>{{ totalOrders }}</h4>
                </div>

                <div class="card small" *ngIf="oesPercentage > 0">
                  <p>⚙️ OES Share</p>
                  <h4>{{ oesPercentage }}%</h4>
                </div>
              </div>
            </div>
            <div class="asp-dashboard__orders"  *ngIf="recentOrdersList?.length > 0">
              <h3>🚛 Recent Orders</h3>

              <div class="order-card" *ngFor="let order of recentOrdersList">
                <div><strong>ORD- {{ order.orderNumber }} • {{ order.registrationNumber }} • ₹{{ order.totalAmount }}</strong>
                  <p *ngIf="order.orderStatus && order.orderStatus !== 'draft'">  {{ getOrderStatusText(order.orderStatus) }} 
                    <span *ngIf="order.createdAt"> • ETA: {{ order.createdAt | date:'MMM d' }}</span>
                  </p>
                </div>
                <div class="order-footer" *ngIf="order.orderStatus && order.orderStatus !== 'draft'">
                  <span class="status-order" [ngClass]="getOrderStatusClass(order.orderStatus)"> {{ getOrderStatusIcon(order.orderStatus) }} {{ order.orderStatus | titlecase }}</span>
                  <button (click)="loadorderdetails(order.orderKey)">Track ➜</button>
                </div>
              </div>
            </div>
            <div class="asp-dashboard__requests"  *ngIf="requestProgressList?.length > 0">
              <h3>⚡ Requests in Progress</h3>

              <div class="request-card" *ngFor="let req of requestProgressList">
                <div><strong>REQ-{{ req.requestId }} • {{ formatItemNames(req.itemNames) }}</strong>
                <p>{{ getRequestStatusText(req.status) }}</p>
                <div class="request-footer">
                  <span class="status" [ngClass]="getStatusClass(req.status)"> {{ getStatusMessage(buildStatusDetails(req.status)) }}</span>
                  <button (click)="navigateToDetails(req.requestId)">Open ➜</button>
                </div>
              </div>
            </div>
            <div class="activity-footer"   *ngIf="totalSavings > 0">
                💡 Great going! You’ve saved <strong>₹{{ totalSavings | number:'1.2-2' }}</strong> this month with <strong>Autoverse</strong>.
            </div>
          </div>
          </div>
    </div>
</div>
      <ng-template #orderlistContainer></ng-template>